import React, { Component, useState, useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';
import '../../i18n'
import { useAuth } from './../Authentication/AuthenticationProvider';
import usePageTitle from '../../Hooks/usePageTitle';
import { RecipientDeliveryDetails } from './Payment/RecipientDeliveryDetails';
import SvgIconInfo from '../UI/Icons/SvgIconInfo';
import ReactHtmlParser from 'html-react-parser';
import { APIGet, APIPost, getEnvironment } from './../API/APIRequest';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Button from '../UI/Buttons/Button';
import "./minicorp.scss";
import useBodyClass from '../../Hooks/useBodyClass';
import useResize from '../../Hooks/useResize';
import { GenericErrorBox } from '../UI/ErrorBox/GenericErrorBox';

export function MiniCorpSubs(props, ref, multi = true) {
    const [activeUser, setActiveUser] = useState(0);
    const [initialData, setInitialData] = useState([]);
    const [optionalEmail, setOptionalEmail] = useState(false);
    const [recipients, setRecipients] = useState([]);
    const [submittedUser, setSubmittedUser] = useState([])
    const [hasFilledSlot, setHasFilledSlot] = useState()
    const [numberSlot, setNumberSlot] = useState()
    const [hasUpdated, setHasUpdated] = useState([])
    const [data, setData] = useState([]);
    const [errors, setErrors] = useState([]);
    const [variantName, setVariantName] = useState();
    const recipientRefs = useRef([]);
    const { environment } = useParams();
    const { orderid } = useParams();
    const [IsInvalid, setIsInvalid] = useState({ userEmail: false, firstName: false, lastName: false });
    const [isLoading, setIsLoading] = useState(false);
    const [inviteSent, setInviteSent] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [orderIsInvalid, setOrderIsInvalid] = useState("unknown")
    const [orderID, setOrderID] = useState();
    const [shouldSkipBlur, setShouldSkipBlur] = useState("");
    const [userExists, setUserExists] = useState([])
    const [keepSubmitDisabled, setKeepSubmitDisabled] = useState("");
    const [searchParams] = useSearchParams();
    const [showCancelButton, setShowCancelButton] = useState("");
    const [showDisabledButtonMessage, setShowDisabledButtonMessage] = useState(false);
    
    const { t, i18n } = useTranslation();
    //languages
    usePageTitle(`Manage Recipients -  ${props.brandingElement?.id}`);
    useBodyClass('manage-users')
     //token assignment

    const  userTokenFromUrl = searchParams.get('token');
    const  userDataFromSession= sessionStorage.getItem("adtoken");
    let parsedUserData= userDataFromSession ? JSON.parse(userDataFromSession) : "";
    let userToken = parsedUserData.token || userTokenFromUrl;


    let userorderID = sessionStorage.getItem("orderId");
     
    const location = useLocation();

    const { url } = location.state || {};
    let windowSize = useResize();
    const latestDetailsRef = useRef({});
    const returnUrl = searchParams.get('returl');
    const decodedReturnUrl = returnUrl ? decodeURIComponent(returnUrl) : '';


    const addError = (type, message) => {
        setErrors(prev => [...prev, { type, message }]);
    };

    const loadRecipients = async () => {

     
        await APIGet({
            "controller": "order",
            "action": "GetCorporateRecipients",
            "identifier": orderid || userorderID,
            "environment": environment,
            "data": data,
            "headers": [{
                "key": "UserToken",
                "value": userToken
            }]
        })
            .then(function (response) {
                const data = response.data;
                const totalSlots = data?.recipientslots[0]?.numberOfSlots || 0;
                const filledSlot = data?.recipientslots[0]?.filledSlots || 0;
                const corporateRecipients = data?.corporaterecipients || [];

                const alreadyThere = corporateRecipients.map((item, index) => ({
                    id: index + 1,
                    firstName: item.firstName,
                    lastName: item.lastName,
                    userEmail: item.email,
                    recipientType: item.recipientType,
                    allocated: true,
                }));

                const emptyCount = totalSlots - alreadyThere.length;

                const emptySlots = Array.from({ length: emptyCount }, (_, i) => ({
                    id: alreadyThere.length + i + 1,
                    firstName: "",
                    lastName: "",
                    userEmail: "",
                    allocated: false,
                }));
                setData(data)
                setNumberSlot(totalSlots)
                setInitialData(alreadyThere.concat(emptySlots));
                setActiveUser(filledSlot)
                setHasFilledSlot(filledSlot > 0)
                
                const totalPositions = alreadyThere.concat(emptySlots)
                setInviteSent(Array(totalPositions?.length).fill("notResent")); 
   
            })
            .catch(function (error) {
                if (!error.response) addError('network', 'Network issue during POST');
                else addError('Authentication Issue', ` Error: ${error.response?.status || error.message}`);
            })
    }

    const validateCorporateOrder= async()=>{
        await APIGet({
            "controller": "order",
            "action": "validatecorporateOrder",
            "environment": environment,
            "identifier": orderid,
        }).then((response)=>{
            setOrderIsInvalid("false")
            

        }).catch((error)=>{
            setOrderIsInvalid("true")
            setErrors(error);
        });
    }
    useEffect(() => {
        
        validateCorporateOrder();
        loadRecipients();
        LoadSummary();

        if(decodedReturnUrl !== ""){
          setShowCancelButton(true);
        }
        
    }, [])


    const LoadSummary = async () => {
        await APIGet({
            "controller": "order",
            "action": "summary",
            "environment": environment,
            "identifier": orderid || userorderID,
            "data": data,
            "headers": [{
                "key": "UserToken",
                "value": userToken
            }]
        }).then((response) => {
            const data = response?.data;
            setVariantName(data?.order?.lines[0]?.displayname || data?.order?.lines[0]?.shortdescription)
     
        }).catch((error) => {
            var unexpected = [];
            unexpected.push("error.unexpected");
            setErrors(unexpected);
        })
    }

    useEffect(() => {
        if (numberSlot > 0) {
            setHasUpdated(Array(numberSlot).fill(false)
                .map((e, index) => ({ id: index, open: false })))
        }
            //setHasUpdated(data?.recipientslots[0]?.numberOfSlots).fill(false);
    }, [numberSlot]);

    useEffect(() => {
        if (initialData?.length) {
            const initial = initialData.map(r =>
                r.allocated
                    ? r // keep full values for allocated records
                    : {
                        ...r,
                        firstName: "",
                        lastName: "",
                        userEmail: "",
                    }
            ); 
            setRecipients(initial);

            }

    }, [initialData, activeUser]);


    const removeSkipAllocationEntryForID=(updatedDetails)=>{

        const newData= submittedUser?.filter(
            recipient => !(recipient.id === updatedDetails.id && recipient.firstName === "")
        );

        setSubmittedUser(newData);// to be placed someplace else


    }

    const handleAddUser = (index) => {
        const ref = recipientRefs.current[activeUser];
        if (!ref?.ValidationOnSubmit) return;

        const { status, details } = ref.ValidationOnSubmit();
 
        const updatedDetails = latestDetailsRef.current[index];
  
        if (!updatedDetails) {
            console.warn("No updated details found for index:", index);
            return;
        }
          
        const emailToCheck = updatedDetails.userEmail?.toLowerCase();
       
        //in scenarios for removing skipped entries for same index
        if(emailToCheck){
            removeSkipAllocationEntryForID(updatedDetails);
        }
       
        //for checking already stored users
        const existsInCorporate = data.corporaterecipients?.some(
            recipient => recipient.email?.toLowerCase() === emailToCheck && recipient.action === "remove"
        );
        
        //for checking in temp position data used to display users
        const existsInInitial = initialData?.some(
            recipient => emailToCheck && recipient.userEmail?.toLowerCase() === emailToCheck &&
                         recipient.id !== updatedDetails?.id
        );
        
       //fir checking in temp data
       const existsInSubmittedList = submittedUser.some(
        recipient => recipient.userEmail?.toLowerCase() === emailToCheck && recipient.action === "remove"
       );
       
       //for preventing addition of dublicate entries with action types add and remove ( happens when we delete a stored user and readd the same user)
       if(existsInCorporate && existsInSubmittedList){

           let newData = submittedUser.filter(
                recipient =>
                  !(
                    recipient.userEmail?.toLowerCase() === emailToCheck &&
                    recipient.action === "remove"
                  )
              );
              setSubmittedUser(newData);
        } 
        
        else{
        
        //for preventing storing duplicate users
        const userExists = existsInInitial || existsInCorporate;

        if(userExists){
            setUserExists((prev) => {
                const updated = [...prev];
                updated[index] = true;
                return updated;
            });
            
            return;

        }else{
            setUserExists((prev) => {
                const updated = [...prev];
                updated[index] = false;
                return updated;
            });
        }
    }
        if (status) {
            const userWithAllocation = { ...updatedDetails, allocated: true };
            const submittedWithAllocation = {
                ...updatedDetails,
                partyId: null,
                inviteId: null,
                recipientType: "Invitee",
                action: "add"
            }; 
            // Store valid details
            setInitialData((prev) => {
                const updated = [...prev];
                updated[index] = userWithAllocation;
                return updated;
            });
            
            //to not override entry with same index, we are just pushing entries
            const userAlreadyAdded = submittedUser.find((recipient)=>(recipient.userEmail?.toLowerCase() === updatedDetails.userEmail?.toLowerCase()) && (recipient.id === updatedDetails.id)) || false
            if(!userAlreadyAdded){
               setSubmittedUser(prev => [...prev, submittedWithAllocation]);
            }

            //for new user
            setInviteSent(prev=>{ 
                const newInviteSent = [...prev]; 
                newInviteSent[index]="newUser";
                return newInviteSent });

            setHasUpdated((prev) =>
                prev.map((item) =>
                    item.id === index ? { ...item, open: false } : item
                )
            );
            // Move to the next user if any 1

           findNextUnallocatedIndex(index);
        
           setKeepSubmitDisabled(false);

        }
    }

 

    const handleChildDetailsChange = (index, updatedDetails) => {
        latestDetailsRef.current[index] = {...updatedDetails, id:index+1};

        const userWithAllocation = { ...updatedDetails, allocated: true };
        setRecipients((prev) => {
            const newData = [...prev];
            newData[index] = userWithAllocation;
            return newData;
        });
    
    };

    const findNextUnallocatedIndex=(index) =>{

        const nextUnallocatedIndex = recipients.findIndex(
            (item, i) => i > index && item.allocated === false
        );

        if (nextUnallocatedIndex !== -1) {
            setActiveUser(nextUnallocatedIndex);
            
        } else {
            // If none found, maybe go to the first unallocated slot, or just stay
            const firstUnallocated = recipients.findIndex((item, i) => item.allocated === false && i !== index);
            setActiveUser(firstUnallocated !== -1 ? firstUnallocated : null); //Or -1
        }

    }


    const handleSkipUser = (index) => {

        setUserExists([]);

        const updateAllocation = (list) => list.map((item, i) => i===index ? {...item, allocated:true} : item)
        
        setInitialData((prev)=>updateAllocation(prev));
        setRecipients((prev)=>updateAllocation(prev));

       
       // Also update submittedUser after recipients state updates
        setSubmittedUser((prev) => {

            // Add the newly skipped user, but prevent duplicates:
            let skippedEntry= {
                id:index+1,
                firstName:"",
                lastName:"",
                email:"",
                allocated:true,
            }

                const filtered = prev.filter(
                    (user) => !(user.id === skippedEntry.id && user.action !== "remove")
                  );
                
                  return [...filtered, { ...skippedEntry}];
          
        });

        if (!hasFilledSlot) {

            findNextUnallocatedIndex(index)
            
        } else {

            setActiveUser(index + recipients.length);
        }

        setKeepSubmitDisabled(false);
    }

    const handleOpenAddUser = (e, index) => {
        e.preventDefault();
    
        setHasUpdated((prev) =>
            prev.map((item) =>
                item.id === index ? { ...item, open: true } : item
            )
        );
        setActiveUser(index);

   }

    const handleRemoveUser = (e, index) => {
        e.preventDefault();
    
        if (!initialData[index]) {
            console.log("No user found at index", index);
            return;
        }
        
        // Caching current user before statee updations
        const currentUser = initialData[index];
        
        const corporateRecipient = data.corporaterecipients.find(
            (recipient) => recipient.email?.toLowerCase() === currentUser.userEmail?.toLowerCase()
        ) || {};
        
        //false in case of temp user
        const inviteeId = corporateRecipient.email ? corporateRecipient.inviteId : false;
    
        const userWithAllocation = {
            ...currentUser,
            action: "remove",
            recipientType: corporateRecipient.recipientType || "",
            partyId: corporateRecipient.partyId || "",
            inviteId: inviteeId || "",
            allocated: true,
        };
    
        const updatedData = [...initialData];

        updatedData[index] = {
            ...updatedData[index], // keep the same id or other untouched fields
            id: index + 1,
            firstName: "",
            lastName: "",
            userEmail: "",
            allocated: false,
        };

        if (inviteeId || inviteeId === null) {
            
            //for submitted users--------------------------------------------------------------

            setInitialData(prev => {
                const updated = [...prev];
                updated[index] = {
                    ...updated[index],
                    firstName: "",
                    lastName: "",
                    userEmail: "",
                };
                return updated;
            });
    
            // Update submittedUser in one clean operation
            setSubmittedUser(prev => {
                const filtered = prev.filter(user => user.id !== currentUser.id);
                return [...filtered, userWithAllocation];
            });
    
            setActiveUser(index);
            

        } else {
            
            //for unsubmitted users----------------------------------------------------------------------

            setInitialData(updatedData);
            
            //no storing of removed temp entries, only ejecting. 
            setSubmittedUser(prev =>
                prev.filter(user => user.userEmail?.toLowerCase() !== currentUser.userEmail?.toLowerCase())
            );
           
        }
        
         handleOpenAddUser(e, index);  //opening edit details block 
        //setKeepSubmitDisabled(false);  
    };
    

    const getResendInvite = async (e, index) => {
        e.preventDefault();
        //   inviteId: item?.inviteId;
        const inviteId = data?.corporaterecipients[index]?.inviteId ;

        await APIPost({
            "controller": "order",
            "action": "ResendCorporateInvite",
            "identifier": orderid || userorderID ,
            "environment": null,
            "data": [{ "inviteId": inviteId }],
            "headers": [{
                "key": "UserToken",
                "value": userToken
            }]
        }).then((response) => {
         
            setInviteSent(prev=>{ 
                const newInviteSent = [...prev]; 
                newInviteSent[index]="resent";
                return newInviteSent});

        }).catch((error) => {
            // var unexpected = [];
            // unexpected.push("error.unexpected");
            // setErrors(unexpected);
        })

    }

    useEffect(() => {

       checkForDisableSubmit();

    },[submittedUser, hasFilledSlot, initialData, activeUser, hasUpdated])
    

    const checkForDisableSubmit = () => {
        
        setShowDisabledButtonMessage(false); //resetting error on every change, will be shown again on submit if conditions are met
        
        //conditions: On first time adding users -> if all slots are skipped or atleast one user has been added - submit will be enabled else disabled.
        // When re-adding users next time -> if prefilled slots exists, and a specific user's details are being edited or added then submit will be disabled else enabled. If no prefilled slots -> will behave as first time.

        const allSlotsSkipped = initialData.length > 0 ? initialData?.every(user => user.allocated === true) : false;
        const hasAnyNewUser = submittedUser.length > 0 ? submittedUser?.some(user => user.firstName?.trim() !== "") : false;
        const userEditStateTrue = initialData.some((user, index) => {
          return (
            index === activeUser &&
            (hasUpdated[index]?.open)
          );
        });

        if (((!allSlotsSkipped && !hasAnyNewUser) && !hasFilledSlot)) {

            setKeepSubmitDisabled("Initial_Validation_Failed");

        }else if(hasFilledSlot && userEditStateTrue){

            setKeepSubmitDisabled("User_Edit_State_True");

        }else{
            setKeepSubmitDisabled(false);   
        }
   }
    

    const submitAllUsers = async (e) => {
        e.preventDefault();

        if (keepSubmitDisabled){

            setShowDisabledButtonMessage(true);
            return;

        }


        setIsLoading(true)
        setErrors("");
        const normalized = submittedUser.map(item => ({
            partyId: item?.partyId || null,
            inviteId: item?.inviteId || null,
            firstName: item?.firstName || "",
            lastName: item?.lastName || "",
            email: item?.email || item?.userEmail || "",
            recipientType: item?.recipientType || "",
            action: item?.action || "add"

        }));
        const cleaned = normalized
            .filter(obj => obj && Object.keys(obj).length > 0)
            .filter(obj =>
                obj.firstName.trim() ||
                obj.lastName.trim() ||
                obj.email.trim()
            );

        const payload = {
            orderId: orderID,
            corporaterecipients: cleaned
        };
    

        APIPost({
            "controller": "order",
            "action": "UpdateCorporateRecipients",
            "identifier": orderid || userorderID,
            "environment": null,
            "content_type": "json",
            "data": payload,
            "headers": [{
                "key": "UserToken",
                "value": userToken
            }]

        }).then((response) => {
          
            const returnUrl = searchParams.get('returl');

            const decodedReturnUrl = returnUrl ? decodeURIComponent(returnUrl) : '';
          

            
            // Redirect to external URL
            if (decodedReturnUrl !=='') {
                window.location.href = decodedReturnUrl;
            } else {
                window.location.href = url;
            }
            //setIsLoading(false)

        }).catch((error) => {

            var unexpected = [];
            unexpected.push("error.unexpected");
            setIsLoading(false)
              if (!error.response) addError('network', 'Network issue during POST');
                    else addError('Authentication Issue', ` Error: ${error.response?.status || error.message}`);
            
        }); 
    }

    const redirectToManageAccount=()=>{
       
         if (decodedReturnUrl !=='') {
            window.location.href = decodedReturnUrl;
        } 

    }

    const handleOpenMore = (e) => {
        e.preventDefault();
        setIsOpen(prev => !prev);
    }

    const activerecipient = (index, user) => {
        return (
            <div className="item-wrapper user-allocation">
                <div className="detail-wrapper">
                    <div className="label-wrapper">
                        <div className="label">{t('minicorps.recipientlabel')}  </div>
                        <div>
                            {(recipients[index]?.firstName && recipients[index]?.lastName && (recipients[index]?.email || recipients[index].userEmail)) ?
                             <a href="#" className="meta back-button" onClick={(e) => handleRemoveUser(e, index)}>{t('minicorps.removebuttonlabel')}</a> :
                                <a href="#" className="meta back-button" onClick={(e) => handleOpenAddUser(e, index)}>{t('minicorps.allocateuserbuttonlabel')}</a>
                   
                         }
                       
                        </div>
                    </div>

                    {(recipients[index]?.firstName && recipients[index]?.lastName && (recipients[index]?.email || recipients[index].userEmail)) ?
                        <>
                            <div className="item-container">

                                <div className="item-wrapper">
                            <p> {recipients[index]?.firstName}  {recipients[index]?.lastName}</p>
                            <p> {recipients[index]?.email || recipients[index]?.userEmail} </p>
                                </div>
                            </div>
                            <div className="item-container">
                       
                              <div className="item-wrapper one-row">
                                    {recipients[index].recipientType === 'Beneficiary' ? 
                                        <>  <div className="positive-icon"><span></span> </div>
                                              <p className="meta"> {t('minicorps.activatedlabel')}</p></>

                                        : recipients[index].recipientType === 'Invitee' 
                                        ? 
                                            <>
                                             {inviteSent[index] !== "newUser" ? <>
                                                    <div className="negative-icon"><span></span></div>
                                                    <p className="meta">{t('minicorps.notactivelabel')}</p>
                                                    {inviteSent[index] === "resent" ? <p className="meta">{t('minicorps.invitesentlabel')}</p> :
                                                        inviteSent[index] === "notResent" ? <p className="meta "> <a href="#" className="back-button" onClick={(e) => getResendInvite(e, index)}>{t('minicorps.resendinvitelabel')}</a></p>
                                                            : ""} </> : ""}
                                             </> : ""}
                                   </div>
                               </div>
                        </> :
                        <p>{t('minicorps.notallocatedlabel')}</p>
                    }
                </div>
            </div>
        )
    }

    // useEffect(() => {
    //     const shouldDisableSubmit = initialData.some((user, index) => {
    //       return (
    //         index === activeUser &&
    //         (!hasFilledSlot || hasUpdated[index]?.open)
    //       );
    //     });
      
    //     if (shouldDisableSubmit) {
    //     //   setKeepSubmitDisabled(true);
    //     } else {
    //       setKeepSubmitDisabled(false);
    //     }
    //   }, [activeUser, hasFilledSlot, hasUpdated, initialData]);
      
   
    const rightColumn = `${props?.brandingElement?.corpUserSide || ""}`;
    const topColumn = `${props?.brandingElement?.corpUserTop || ""}`;
    const bottomColumn = `${props?.brandingElement?.corpUserBottom || ""}`;
    const miniCorpError = `${props?.brandingElement?.miniCorpError|| ""}`;
    
    return (

      orderIsInvalid==="true" ? <div className="container-wrapper one-column">
                                    <GenericErrorBox type= "miniCorpError" errors={errors} errorHtml={miniCorpError} /> 
                                </div>

    : orderIsInvalid === "false" ?
    
      <>
       
      <div className={`container-wrapper ${windowSize > 1023 ? 'two-columns' : ''}`} >
         
            {windowSize < 1024 &&
            <section>
                    <div className="container">
                        <div className="item-container">
                            <div className="item-wrapper">
                                <a className={`view-more  ${isOpen ? 'more-info-open' : ''}`} href="#" onClick={(e) => handleOpenMore(e)}>
                                    <span>{t('minicorps.moreinfolabel')} </span>
                                      </a>
                            </div>
                        </div>
                    </div> 
                </section>
            }
            <section className={windowSize < 1024
                ? `extra ${isOpen ? 'open' : ''}`
                : 'rightside-column'}
              >
                <div className="container">
              
                    <div className="item-container">
               
                        <div className="item-wrapper">
                            <SvgIconInfo />
                      
                            {ReactHtmlParser(rightColumn)}
                        </div>
                     
                    </div>
                </div>
            </section>
                    <section> 
                        <div className="container">
                            <div className="item-container">
                                <div className="item-wrapper">
                                    <h2 class="module-heading">{t('minicorps.adduserslabel')}</h2>

                                </div>
                                <div className="item-wrapper">
                                    <p><strong>{t('minicorps.orderlabel')}: </strong>{variantName} - {initialData?.length} {t('minicorps.userslabel')}</p>
                                </div>
                                <div className="item-wrapper">
                            {ReactHtmlParser(topColumn)}
                
                                </div>
                            </div>
                        </div>
                {errors.length <= 0 ?
            
                <form onSubmit={submitAllUsers}> 
                 
                    {initialData.map((user, index) => (
                        
                        <div className="container">
                            <div className="item-container">
                                <div className="item-wrapper">
                                    <h2 className={`module-heading ${index !== activeUser && ((!recipients[index]?.allocated && !hasFilledSlot) && 'disabled')}`}>{t('minicorps.userlabel')} {index + 1} </h2>
                                </div>
                            </div>
                            {

                                ((index === activeUser && !hasFilledSlot) || (index === activeUser && hasUpdated[index]?.open)) && ( <>

                                {userExists[index]  ?  <GenericErrorBox errors="minicorps.useralreadyexist"/> : "" }

                                    <RecipientDeliveryDetails
                                        key={index}
                                        detailType="recipient"
                                        multi={true}
                                        setRecipientDetails={newDetails =>
                                            setRecipients(arr => {
                                                const copy = [...arr];
                                                copy[index] = newDetails;
                                                return copy;
                                            })
                                        }
                                        recipientDetails={recipients[index]}
                                        optionalEmail={optionalEmail}
                                        setIsFilled={() => { }}
                                        setIsInvalid={setIsInvalid}
                                        IsInvalid={IsInvalid}
                                        IsFilled={{}}
                                        user={user}
                                        userIndex={index}
                                        onDetailsChange={handleChildDetailsChange}
                                        shouldSkipBlur={shouldSkipBlur}
                                        setShouldSkipBlur={setShouldSkipBlur}
                                        ref={el => recipientRefs.current[index] = el}
                                        openState="remove"

                                    />

                                    <div className="item-container">
                                        <div className="item-wrapper one-row">
                                            <button type="button" className="primary-button" onClick={() => handleAddUser(index, recipients[index])}>{t('minicorps.adduserlabel')}</button>
                                            <button type="button" className="ghost-button" onMouseDown={() => setShouldSkipBlur(true)} onClick={() => { handleSkipUser(index)}}>{t('minicorps.skipallocationlabel')}</button>
                                        </div>
                                    </div>

                                </>)}
                        
                            {!hasUpdated[index]?.open && index === activeUser && hasFilledSlot && activerecipient(index, user)}
                            {index !== activeUser && hasFilledSlot && activerecipient(index, user)}
                            {(!hasFilledSlot && (activeUser !== index && recipients[index]?.allocated)) && activerecipient(index, user)}
                        </div>
                    ))}
                    <div className="container">
                        <div className="item-container">
                            <div className="item-wrapper">
                                    {ReactHtmlParser(bottomColumn)}
                            </div>
                        </div>
                         
                         {showDisabledButtonMessage && <GenericErrorBox errors={keepSubmitDisabled === "Initial_Validation_Failed" ? "minicorps.norecipientaddederror" : "minicorps.editstatetrue"}/>}
                         

                        <div className="item-container">
                                <div className="item-wrapper one-row">
    
                                {(!isLoading ? <Button isDisabledLook={keepSubmitDisabled ? "true" : "false"} type="submit" buttonSize="small">{t('minicorps.continuebuttonlabel')}</Button>
                                : isLoading ? <Button type="submit" hasIcon="updating" isDisabled="true" buttonSize="small">{t('minicorps.continuebuttonlabel')}</Button>
                                : "")
                                }
                                {showCancelButton ? <button className="secondary-button" type="button" onClick={(e)=>{redirectToManageAccount(e)}}>{t('minicorps.cancelbuttonlabel')} </button> : "" }
                              
                            </div>
                        </div>
                    </div>

                        </form>
                    :


                    <div className="container">
                        <div className="item-container">
                            <div className="item-wrapper">
                                <p class="module-heading" style={{ textAlign: 'center' }}>{errors[0]?.type} </p>

                            </div>
                        </div>
                    </div>
                }
            </section>
            
            
         
        </div>

      </> 

        :""
    )
}